// Import all rules
import afterOrEqualNow from './after-or-equal-now';

// Export all rules as an array
export default [
  afterOrEqualNow
  // Add new rules here
];
